export const h = {
  stat:{
    zcrs:"注册人数",
    scrs:"首充人数",
    scje:"首充金额",
    yhkbs:"银行卡笔数",
    yhkrj:"银行卡入金",
    usdtbs:"USDT笔数",
    usdtrj:"USDT入金",
    cjbs:"出金笔数",
    cjje:"出金金额",
    tdzrs:"团队总人数"
  },
	login:{
		login:"登录",
		pleaseusername:"请输入用户名",
		pleasepassword:"请输入密码",
		checkname:"请输入正确的用户名",
		checkpass:"密码不能小于3位",
	},
	navbar:{
		home:"首页",
		mycenter:"个人中心",
		outlogin:"退出",
		close:"关闭",
		editLanguage:"编辑语言"
	},
	vip:{
    ce:"存取差",
    ywy:"业务员",
		nickname:"昵称",
		pleasenickname:"请输入昵称",
		username:"用户名",
		pleaseusername:"请输入用户名",
		arealogin:"登录地区",
		pleasearealogin:"请输入登录地区",
		nationality:"国籍",
		pleasenationality:"请选择国籍",
		depositstatus:"入金状态",
		pleasedepositstatus:"请选择入金状态",
		createtime:"创建时间",
		logintime:"登录时间",
		startime:"开始时间",
		endtime:"结束时间",
		no:"编号",
		shangji:"直推上级",
		keyongmoney:"可用余额",
		baozhengjing:"保证金",
		fudongyingkui:"浮动盈亏",
		zicantotal:"资产总额",
		yaoqingma:"邀请码",
		zongrujing:"总入金",
		zongchujing:"总出金",
		loginIp:"登录ip",
		zuihoulogin:"最后登录时间",
		shoucirujingmoney:"首次入金金额",
		shoucirujingtime:"首次入金时间",
		kaitongtime:"开通时间",
		keyong:"可用",
		daoshi:"导师",
		dongjie:"冻结",
    jiedong:"解冻",
		chujingstate:"出金状态",
		xiajichujingstate:"下级出金状态",
		caozuo:"操作",
		chakan:"查看",
		heji:"合计",
		moneytotal:"总余额",
		paixu:"排序",
		daochu:"导出",
		huiyuanguanli:"会员管理",
		yonghu:"用户",
		search:"查询搜索",
		reset:"重置",
		delete:"删除",
		kickout:"踢出",
		notlogin:"未登录",
		editLanguage:"编辑语言",
		yourujing:"有入金",
		wurujing:"无入金",
		todayreg:"当天的注册量：",
		newvipnum:"新会员加入数量：",
		remark:"备注",
    juese:"角色",
    xiugaimima:"修改密码",
    jiumima:"旧密码",
    shurujiumima:"请输入旧密码",
    xinmima:"新密码",
    shuruxinmima:"请输入新密码",
    gerenzhongxing:"个人中心",
    yonghuxinxi:"用户信息"
	},
	info:{
		home:"主页",
		user:"用户编号",
		nickname:"昵称",
		account:"账号",
		identity:"身份证号",
		phone:"手机号码",
		nationality:"国籍",
		Balance:"余额管理",
		real:"真实账户",
		zhongmongy:"总余额",
		keyongmoney:"可用余额",
		jiaoyidongjie:"交易冻结",
		shishilirun:"实时利润",
		shishikeyong:"实时可用",
		xunizhanghu:"虚拟账户",
		churujinguanli:"出入金管理",
		chakanzijinjilu:"查看资金记录",
		rujinjilu:"入金记录",
		rujinjine:"入金金额",
		jiaoyibishu:"交易笔数",
		chujinjilu:"出金记录",
		chujinjine:"出金金额",
		jiaoyiguanli:"交易管理",
		lishijilu:"历史记录",
		chakanlishi:"查看历史交易信息",
		jiaoyishoushu:"交易手数",
		jiaoyiyingkui:"交易盈亏",
		dangqianchicang:"当前持仓",
		chakandangqianchicang:"查看当前持仓信息",
		dangqianguadan:"当前挂单",
		chakanguadanliebiao:"查看挂单列表",
		guadanbishu:"挂单笔数",
		yongjinguanli:"佣金管理",
		duanwei:"段位",
		wu:"无",
		zhishushangji:"直属上级",
		shangjidaili:"上级代理",
		xiajituandui:"下级团队",
		shurudailiname:"请输入代理名称",
		chakan:"查看",
		fanyongjie:"返佣金额",
		fanyongbishu:"返佣笔数",
		chakanyongjinjilu:"查看返佣记录",
		chakanyonghuinfo:"查看用户详情",
		chakanwenjuan:"查看调查问卷",
		resetpassword:"重置密码",
    resetjypassword:"重置提款密码",
		sendmsg:"发送站内信",
		update:"修改",
		unbound:"未绑定",
		weishiming:"未实名",
    yishiming:"已实名",
    shiming:"实名",
		gendan:"跟单管理",
		gensui:"跟随",
		chakangendan:"查看跟单记录",
		dingdanhao:"订单号",
		shoudongpay:"手动充值",
		chakanyongjingjilu:"查看佣金记录",
		xiugaiyonghuxinxi:"修改用户信息",
		queding:"确 定",
		quxiao:"取 消",
		email:"邮 箱",
		selguoji:"请选择国籍",
		sendusermsg:"给用户发送消息",
		title:"标题",
		shurutitle:"请输入消息标题",
		content:"内容",
		shurucontent:"请输入消息内容",
		zhenshi:"真实",
		xuni:"虚拟",
		fangxiang:"方向",
		zhanghu:"账户",
		add:"增加",
		less:"扣除",
		type:"类型",
		guanliyuanpay:"管理员充值",
		pay:"充值",
		money:"金额",
		updategdmsg:"修改跟单信息",
		xinhaoyuan:"信号源",
		yes:"是",
		no:"否",
		updateyongjingmsg:"修改佣金信息",
		qingxuanzejuese:"请选择账号角色",
		zuoduo:"做多",
		zuokong:"做空",
		gensuinicheng:"跟随昵称",
		kaicangjia:"开仓价",
		pingcangjia:"平仓价",
		shousu:"手数",
		pingcangdate:"开仓日期",
		kaicangdate:"平仓日期",
		chakangensuiinfo:"查看跟随详情",
		gensuiuserno:"跟随用户编号",
		gensuiyonghuname:"跟随用户昵称",
		gensuifangshji:"跟随方式",
		number:"数量",
		danwei:"单位",
		zhengxiang:"正向",
		fanxaing:"反向",
		beishu:"倍数",
		shousu:"手数",
		gensuizhuangtai:"跟随状态",
		genjinzhong:"申请跟随中",
		gensuiok:"已同意被跟随",
		gensuino:"已拒绝被跟随",
		chexiao:"撤销",
		gensuidate:"跟随时间",
		chakanlishijiaoyi:"查看历史交易信息",
		chakanguadanlist:"查看挂单列表",
		heyue:"合约",
		daili:"代理",
		huiyuanname:"会员姓名",
		xianjia:"限价",
		zhisun:"止损",
		guadanjia:"挂单价",
		zhiyingzhisun:"止盈止损",
		zhiyingjia:"止盈价",
		zhiyinghuichejia:"止盈回撤价",
		zhisunjia:"止损价",
		zhisunhuichejia:"止损回撤价",
		weiset:"未设置",
		zt:"状态",
		chakanchicangmsg:"查看当前持仓信息",
		shouyiId:"受益人ID",
		xiajiid:"下级用户ID",
		xiajiuser:"下级用户名",
		fanyongmonney:"返佣金额",
		tuihuibaozhengjing:"退回保证金",
		shouxufei:"手续费",
		shouyi:"收益",
		lixi:"利息",
		zengmoney:"赠金",
		zhuijiabaozhengjing:"追加保证金",
		fanyong:"返佣",
		rujing:"入金",
		chujing:"出金",
		chujingshibai:"出金审核失败退款",
		guanliyuanless:"管理员扣减",
		pingzhong:"品种",
		shengqingzhong:"申请中",
		wancheng:"完成",
    jujue:"拒绝",
		chongzhimima:"重置密码成功",
		copy:"复制",
		zhanghaomima:"账号密码",
		tixianmima:"提现密码",
		fenye:"条/页",
		gong:"共",
		tiao:"条",
		ye:"页",
		goto:"前往第",
		outtitle:"你已被登出，可以取消继续留在该页面，或者重新登录",
		outok:"确定登出",
		chongxingdenglu:"重新登录",
		cancel:"取消",
		pingtai:"平台",
		nodata:"暂无数据",
		detuandui:"的团队",
		userID:"用户ID",
		regdate:"注册时间",
		zongrujing:"总入金",
		zuijinrujing:"最近入金",
		ruijinrujingdate:"最近入金时间",
		guoqi:"暂未登录或token已经过期",
    shangjiID:"上级ID",
    shangjiaccount:"上级账号",
    shangjiname:"上级昵称",
    shangjinickname:"上级姓名",
    zhongyingkui:"总盈亏",
    fuying:"浮盈",
    yue:"余额",
    sheng:"升序",
    jiang:"降序",
	},
	history:{
		yingkui:"盈亏",
		guadan:"挂单",
		shijia:"市价",
		gendan:"跟单",
		dangqianjia:"当前价",
		geyelixi:"隔夜利息",
		weituodate:"委托时间",
		pingcangfangshi:"平仓方式",
		dingdanyongjing:"订单佣金",
		shoudongpingcang:"手动平仓",
		qiangzhipingcang:"强制平仓",
		gendanpingcang:"跟单平仓",
		baocang:"爆仓",
		yuguqiangpingjia:"预估强平价",
		kaicangdiqu:"开仓地区",
		ispingcang:"是否确定强制平仓?",
		tips:"提示",
		pincangsucc:"平仓成功",
		queding:"确定",
		cancel:"取消",
	},
	Langswitch: {
	  "en": "英文",
	  "id": "印尼语",
	  "th": "泰国语",
	  "vi": "越南语",
	  "zh": "中文",
	  "fa": "法语",
	  "han": "韩语",
	  "tu": "土耳其语",
	  "pu": "葡萄牙语",
	  "xi": "西班牙语",
	  "jp": "日语",
	  "ar":"阿拉伯语"
	},
}



// WEBPACK FOOTER //
// ./src/i18n/langs/zh.js